import { userConstants } from '../_constants';

const initialState = { userType: [] };


export function users(state = initialState, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case userConstants.GETALL_SUCCESS:
    
      return {
        items: action.users
      };
    case userConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
  
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/users.reducer.js